import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  const {
    t
  } = useLanguage();
  const year = new Date().getFullYear();
  return <footer className="bg-[#3D3D3D] text-white py-12" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-120">
          <div className="text-center md:text-left" data-id="element-121">
            <h3 className="font-heading text-2xl font-bold mb-2" data-id="element-122">
              Glow Studio
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-123">
              &copy; {year} Glow Studio. {t.footer.rights}
            </p>
          </div>

          <div className="flex items-center gap-6" data-id="element-124">
            <span className="text-sm font-medium text-gray-400 uppercase tracking-wider" data-id="element-125">
              {t.footer.follow}
            </span>
            <div className="flex gap-4" data-id="element-126">
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#C9A96E] transition-colors" data-id="element-127">
                <Instagram size={20} data-id="element-128" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#C9A96E] transition-colors" data-id="element-129">
                <Facebook size={20} data-id="element-130" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#C9A96E] transition-colors" data-id="element-131">
                <Twitter size={20} data-id="element-132" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}